<div class="relative p-6 bg-white z-1 dark:bg-gray-900 sm:p-0">
  <div
    class="relative flex flex-col justify-center w-full min-h-screen lg:flex-row dark:bg-gray-900 sm:p-0"
  >
    <ng-content></ng-content>
    <div
      class="items-center hidden w-full self-stretch lg:w-1/2 bg-brand-950 dark:bg-white/5 lg:grid relative"
    >
      <div class="flex items-center justify-center z-1">
        <!-- ===== Common Grid Shape Start ===== -->
        <app-grid-shape />
        <div class="flex flex-col items-center max-w-xs">
          <!-- Logo con Elipse Animada -->
          <div class="relative mb-4">
            <!-- Elipse de carga animada -->
            <div class="absolute inset-0 flex items-center justify-center">
              <div
                class="w-32 h-32 border-4 border-brand-500/20 rounded-full animate-pulse"
              ></div>
              <div
                class="absolute w-56 h-56 border-t-4 border-brand-500 rounded-full animate-spin"
              ></div>
            </div>

            <!-- Logo -->
            <div
              class="w-32 h-32 bg-white dark:bg-gray-800 rounded-full flex items-center justify-center shadow-[0_10px_40px_rgba(70,95,255,0.25)]"
            >
              <img
                src="images/logo/partner-crm-logo.svg"
                alt="Partner CRM"
              />
            </div>
          </div>

          <!-- Título CRM -->
          <h2
            class="z-1 mb-3 text-2xl font-bold text-center text-white dark:text-white/90"
          >
            Partner CRM
          </h2>

          <!-- Subtítulo -->
          <p
            class="text-center text-sm font-medium text-gray-300 dark:text-white/60 tracking-wider"
          >
            CUSTOMER RELATIONSHIP<br />MANAGEMENT
          </p>
        </div>
      </div>
    </div>
    <div class="fixed z-50 hidden bottom-6 right-6 sm:block">
      <app-theme-toggle-two />
    </div>

    <!--
      Las paginas publicas (signin, signup, invitacion, reset) no pasan por
      app-layout, asi que sin esto los toast del ToastService no se pintan en
      ningun sitio: el usuario enviaba el formulario y no veia confirmacion.
    -->
    <app-toast-container />
  </div>
</div>
